import { FluxService } from '@/core/flux.service';

export const flux = new FluxService();
